module.exports = __webpack_public_path__ + "static/img/badge_shop_amazon.5c4f73e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/badge_shop_amazon.png
// module id = OQoY
// module chunks = 1